import React from 'react'
import {
  Tag,
  TagAxisId,
  getDetailedTags,
  isSelectedChildrensFromDetailedTags,
  removeParentsTagIds
} from '@cpsy-rmap-project/tags'
import { CrossRefPaper } from '@cpsy-rmap-project/web-core/crossref'
import Chip from '@material-ui/core/Chip'
import Icon from '@material-ui/core/Icon'
import DoneIcon from '@material-ui/icons/Done'
import Filter1Icon from '@material-ui/icons/Filter1'
import Filter2Icon from '@material-ui/icons/Filter2'
import Filter3Icon from '@material-ui/icons/Filter3'
import Filter4Icon from '@material-ui/icons/Filter4'
import Filter5Icon from '@material-ui/icons/Filter5'
import Filter6Icon from '@material-ui/icons/Filter6'
import Filter7Icon from '@material-ui/icons/Filter7'
import Filter8Icon from '@material-ui/icons/Filter8'
import Filter9PlusIcon from '@material-ui/icons/Filter9Plus'
import _ from 'lodash'

interface Props {
  tag: Tag
  selectedTags: string[]
  handleDetailsChange: (update: Partial<CrossRefPaper>) => void
  selectedTagKey: TagAxisId
}

const MarginIcon: React.FC<{ px?: number; py?: number }> = ({ px, py, children }) => (
  <span
    style={{
      marginLeft: px ? `${px}px` : '3px',
      marginTop: py ? `${py}px` : '0px',
      marginBottom: py ? `${py}px` : '0px'
    }}
  >
    {children}
  </span>
)

const FilterXIcon: React.FC<{ num: number }> = ({ num }) => {
  switch (num) {
    case 0: {
      return <Filter1Icon fontSize="small" />
    }
    case 1: {
      return <Filter2Icon fontSize="small" />
    }
    case 2: {
      return <Filter3Icon fontSize="small" />
    }
    case 3: {
      return <Filter4Icon fontSize="small" />
    }
    case 4: {
      return <Filter5Icon fontSize="small" />
    }
    case 5: {
      return <Filter6Icon fontSize="small" />
    }
    case 6: {
      return <Filter7Icon fontSize="small" />
    }
    case 7: {
      return <Filter8Icon fontSize="small" />
    }
    default: {
      return <Filter9PlusIcon fontSize="small" />
    }
  }
}

const Component: React.FC<Props> = ({ tag, selectedTags, handleDetailsChange, selectedTagKey }) => {
  const selectedIndex = selectedTags.findIndex(tagId => tagId === tag.id)
  const selected = selectedIndex !== -1
  const selectedIcon = () =>
    selectedTags.length === 1 ? (
      <MarginIcon px={5} py={1}>
        <DoneIcon fontSize="small" />
      </MarginIcon>
    ) : (
      <MarginIcon px={5} py={1}>
        <FilterXIcon num={selectedIndex} />
      </MarginIcon>
    )

  // 小タグ・孫タグが選択されている時の親タグの表示
  const detailedTags = getDetailedTags(selectedTags)
  const isSelectChildrens = isSelectedChildrensFromDetailedTags(detailedTags, tag.id)

  return (
    <Chip
      icon={
        selected ? (
          selectedIcon()
        ) : (
          <MarginIcon>
            <Icon fontSize="small" />
          </MarginIcon>
        )
      }
      label={tag.name}
      clickable
      color="default"
      size="small"
      onClick={() => {
        const update = selected ? _.remove(selectedTags, tagId => tagId !== tag.id) : [...selectedTags, tag.id]
        const removedParentsUpdate = removeParentsTagIds(update)
        handleDetailsChange({
          [selectedTagKey]: removedParentsUpdate
        })
      }}
      variant={selected || isSelectChildrens ? 'default' : 'outlined'}
      style={{ margin: '2px', wordBreak: 'break-all' }}
    />
  )
}

export default Component
